import { objectOf, anyOf } from "@altostra/type-validations";
import { nullOrUndefined, string } from "@altostra/type-validations/lib/primitives";

export const isPutCompaniesCompanyIdOauthMcpSettingsRedirectUrisResult = objectOf({
  uri: string,
  state: string,
  last_updated_by_id: anyOf(nullOrUndefined, string),
  last_updated_by_name: string,
  last_updated_at: string,
});
